import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import { ButtonProps } from './Button'

export type BannerButtonProps = ButtonProps & {
  to: string
  activeButton?: boolean
}

export const StyledBannerButton = styled.li`
  box-sizing: border-box;
  list-style: none;
  padding: 16px;
  cursor: pointer;
  font-weight: 300;
  font-size: 24px;
  width: ${props => (props.theme.maxWidth.substring(0, props.theme.maxWidth.length - 2) - 56) / 3 - 34}px;
  text-align: center;
  border: 1px solid white;
  display: flex;
  justify-content: center;
  align-items: center;

  :not(:first-child) {
    margin-left: 28px;
  }

  :hover {
    background-color: white;
    color: black;

    a {
      background-color: white;
      color: black;
    }
  }

  a {
    color: white;
    text-decoration: none;
  }

  ${(props: { activeButton?: any }) =>
    props.activeButton &&
    css`
      background-color: white;
      color: black;

      a {
        background-color: white;
        color: black;
      }
    `}

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

export function BannerButton({ to, activeButton, ...buttonProps }: BannerButtonProps) {
  return (
    <StyledBannerButton
      activeButton={activeButton}
      {...buttonProps}
    >
      <Link to={to}>{buttonProps.label}</Link>
    </StyledBannerButton>
  )
}
